import {Component, input, model, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {SelectModule} from 'primeng/select';

import {Helpers} from '@selpia/shared/utils';
import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-dropdown',
  imports: [FormsModule, SelectModule],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
})
export class DropdownComponent<T, K extends keyof T & string> {
  readonly options = input.required<T[]>();
  readonly model = model<T>();
  readonly label = input<string | undefined>();
  readonly labelKey = input<K>();

  protected readonly innerId = signal(Helpers.generateRandomString()).asReadonly();
  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
